"use client";

import type { AssistantStaticBubbleVariantProps, UserStaticBubbleVariantProps } from "@ui/components/core/BaseChat";
import { userStaticBubbleVariants } from "@ui/components/core/BaseChat";
import { AssistantToolPart } from "../Assistant/toolCallParts";
import type { JSX } from "react";
import type { ChatMessagePart } from "../types";
import { noop } from "../utils";

const defaultAssistantMessageVariants: AssistantStaticBubbleVariantProps = { variant: "cream" };
const defaultUserMessageVariants: UserStaticBubbleVariantProps = { variant: "elevated" };

export function UserTextBubble({
  content,
  userMessageVariants = defaultUserMessageVariants,
}: {
  content: string;
  userMessageVariants?: UserStaticBubbleVariantProps;
}): JSX.Element {
  return <div className={userStaticBubbleVariants(userMessageVariants)}>{content}</div>;
}

interface UserMessagePartProps {
  part: ChatMessagePart;
  assistantMessageVariants?: AssistantStaticBubbleVariantProps;
  userMessageVariants?: UserStaticBubbleVariantProps;
}

export function UserMessagePart({
  part,
  assistantMessageVariants = defaultAssistantMessageVariants,
  userMessageVariants = defaultUserMessageVariants,
}: UserMessagePartProps): JSX.Element | null {
  switch (part.type) {
    case "text":
    case "speech":
      return <UserTextBubble content={part.content} userMessageVariants={userMessageVariants} />;
    case "tool":
      return <AssistantToolPart part={part} animate={false} assistantMessageVariants={assistantMessageVariants} />;
    case "custom": {
      const CustomPart = part.render;

      return <CustomPart onComplete={noop} />;
    }
    default:
      return null;
  }
}
